import type { ReactNode } from 'react'
import { Box } from '@mui/material'

type ClimateContextBarProps = {
  hazardControl: ReactNode
  emissionControl: ReactNode
  horizonControl?: ReactNode
}

const ClimateContextBar = ({ hazardControl, emissionControl, horizonControl }: ClimateContextBarProps) => {
  const hasHorizon = Boolean(horizonControl)

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1.5,
        gridTemplateAreas: hasHorizon
          ? {
              xs: '"hazard" "emission" "horizon"',
              md: '"hazard hazard" "emission horizon"',
              lg: '"hazard emission horizon"',
            }
          : {
              xs: '"hazard" "emission"',
              md: '"hazard emission"',
            },
        gridTemplateColumns: hasHorizon
          ? {
              xs: '1fr',
              md: 'repeat(2, minmax(0, 1fr))',
              lg: 'minmax(300px, 1.25fr) minmax(0, 1fr) minmax(0, 1fr)',
            }
          : {
              xs: '1fr',
              md: 'minmax(300px, 1.25fr) minmax(0, 1fr)',
            },
        alignItems: 'stretch',
      }}>
      <Box sx={{ gridArea: 'hazard', minWidth: 0 }}>{hazardControl}</Box>
      <Box sx={{ gridArea: 'emission', minWidth: 0 }}>{emissionControl}</Box>
      {hasHorizon && <Box sx={{ gridArea: 'horizon', minWidth: 0 }}>{horizonControl}</Box>}
    </Box>
  )
}

export default ClimateContextBar
